import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22 14.66V5.5A1.5 1.5 0 0 0 20.5 4H5a1.5 1.5 0 0 0-1.5 1.5v10A1.5 1.5 0 0 0 5 17h7.66M8.5 4v13M7 17v3m4.5-3v3" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "m13 13 13.5 5.4-5.76 2.34-2.34 5.76z" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }